import { useGitFilePreview } from '@/react/portainer/gitops/queries/useGitFilePreview';

/**
 * Base parameters for Git Helm chart operations
 */
export type GitHelmChartBaseParams = {
  /** The path to the chart within the repository */
  chartPath: string;
  /** The Git reference (branch/tag) */
  reference?: string;
  /** Resolves URL and auth from the stored Source record */
  sourceId?: number;
};

type GitHelmChartParams = GitHelmChartBaseParams & {
  /** The command to run (chart, values, readme) */
  command?: 'chart' | 'values' | 'readme';
};

const fileMap = {
  values: 'values.yaml',
  chart: 'Chart.yaml',
  readme: 'README.md',
} as const;

export function useGitHelmChartValues(
  params: GitHelmChartParams,
  enabled = true
) {
  const command = params.command || 'values';
  const targetFile = params.chartPath
    ? `${params.chartPath}/${fileMap[command]}`
    : fileMap[command];

  return useGitFilePreview(
    {
      targetFile,
      reference: params.reference || 'refs/heads/main',
      sourceId: params.sourceId,
    },
    {
      enabled: !!params.sourceId && !!params.command && enabled,
      select: (data) => ({ values: data }),
    }
  );
}
